// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { carouselStyles } from "@steiner/Overrides/Components/ProductCompareCarousel";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

carouselStyles.attributeWrapper = {
    css: css`
        margin-top: 40px;
        width: 100%;
        max-width: 100%;
    `,
};

carouselStyles.attributeContainer = {
    css: css`
        width: 100%;
        max-width: 100%;
        border-radius: 4px;
        background-color: ${color("common.white")};
        box-shadow: 0 0 9px 0 ${color("primary", 0.15)};
    `,
};

carouselStyles.attributeLabel = {
    as: "p",
    size: 15,
    weight: "bold",
    color: "common.white",
    css: css`
        letter-spacing: 0;
        line-height: 20px;
        padding: 10px 10px 10px 15px;
        background: ${color("primary")};
        min-height: 36px;
        &.first-item {
            border-radius: 4px 4px 0 0;
        }
    `,
};

carouselStyles.attributeValue = {
    as: "p",
    size: 15,
    css: css`
        letter-spacing: 0;
        line-height: 20px;
        text-align: center;
        min-height: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
};

carouselStyles.carouselCellGridItem = {
    width: 12,
    css: css`
        &&&& {
            flex-basis: 100%;
            max-width: 100%;
            margin: 0 auto;

            .swiper-slide {
                // to make all slider same height
                height: auto;
                // To fix swiper render issue
                margin-top: 1px;
                margin-bottom: 1px;
                max-width: 317px;
                &.swiper-slide-active > div {
                    padding-left: 0;
                    border-left: none;
                }
                ${xScreen("lte", "sm")} {
                    max-width: 352px;
                }
                ${xScreen("lte", "xs")} {
                    max-width: 100%;
                }
            }
        }
    `,
};

carouselStyles.attributeLabelText = {};

carouselStyles.attributeValueText = {};
